module.exports = __webpack_public_path__ + "img/menu-icon.842c5a92.svg";